type TestidFunc = (...args: (string | undefined)[]) => { 'data-testid'?: string };

export function buildTestid(prefix?: string): TestidFunc {
  return (...args) => ({
    'data-testid': [prefix, ...args.filter((arg: string | undefined) => !!arg)].join('-'),
  });
}
